/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormQuestionUpdateStatus
 */
export interface FormQuestionUpdateStatus {
    /**
     * 
     * @type {string}
     * @memberof FormQuestionUpdateStatus
     */
    status: FormQuestionUpdateStatusStatusEnum;
}

export function FormQuestionUpdateStatusFromJSON(json: any): FormQuestionUpdateStatus {
    return FormQuestionUpdateStatusFromJSONTyped(json, false);
}

export function FormQuestionUpdateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormQuestionUpdateStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function FormQuestionUpdateStatusToJSON(value?: FormQuestionUpdateStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

/**
* @export
* @enum {string}
*/
export enum FormQuestionUpdateStatusStatusEnum {
    DONE = 'DONE',
    FLAGGED = 'FLAGGED',
    PENDING = 'PENDING'
}


